import { ACADEMIA_HERO_BANNERS, academiaHeroImageUrl } from '../../constants/academiaPublicHero';

export const AUTH_MARKETING_BACKGROUND = academiaHeroImageUrl(ACADEMIA_HERO_BANNERS.campus2);

/** Fond bordeaux login / register : photo campus à droite, texte lisible à gauche. */
export default function AuthMarketingAsideBackground() {
  return (
    <div className="primary-gradient pointer-events-none absolute inset-0 overflow-hidden">
      <img
        src={AUTH_MARKETING_BACKGROUND}
        alt=""
        aria-hidden
        className="absolute inset-y-0 right-0 h-full w-[min(100%,58%)] object-cover object-center opacity-50"
        onError={(event) => {
          (event.target as HTMLImageElement).style.display = 'none';
        }}
      />
      <div
        className="absolute inset-0 bg-gradient-to-r from-[#6b1b18]/95 via-[#872320]/88 to-[#872320]/35"
        aria-hidden
      />
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-[-10%] right-[-10%] h-[80%] w-[80%] rounded-full bg-primary-container blur-[120px]" />
        <div className="absolute bottom-[-20%] left-[-10%] h-[60%] w-[60%] rounded-full bg-tertiary-container blur-[100px]" />
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.05) 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        />
      </div>
    </div>
  );
}
